export default "__VITE_ASSET__D_Xmqr5H__"